<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex"></Header>
    <el-image
      class="bg_img"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_1.png"
    ></el-image>
    <el-image
      class="bg_img1"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_2.png"
    ></el-image>
    <el-image
      class="bg_img2"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_3.png"
    ></el-image>
    <div class="nav">
      <div class="nav_head">
        <img
          @click="returnPage"
          class="img"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/return.png"
          alt=""
        />
        <div class="nav_title">二白机器人官方网站隐私政策</div>
      </div>
      <div class="list">
        <div class="list_item" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabIndex: -1,
      list: [
        {
          title: "隐私政策",
          text: "本网站尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本网站会按照本隐私权政策的规定使用和披露您的个人信息。但本网站将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本网站不会将这些信息对外披露或向第三方提供。本网站会不时更新本隐私权政策。 您在同意本网站服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本网站服务使用协议不可分割的一部分。",
        },
        {
          title: "适用范围",
          text: "(a) 在您使用本网站网络服务，或访问本网站平台网页时，本网站自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；\n您了解并同意，以下信息不适用本隐私权政策：\n(a) 本网站收集到的您在本网站发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；\n(b) 违反法律规定或违反本网站规则行为及本网站已对您采取的措施。",
        },
        {
          title: "信息使用",
          text: "(a)本网站不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本网站（含本网站关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。\n(b) 本网站亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本网站平台用户如从事上述活动，一经发现，本网站有权立即终止与该用户的服务协议。",
        },
        {
          title: "信息披露",
          text: "在如下情况下，本网站将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：\n(a) 经您事先同意，向第三方披露；\n(b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；\n(c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；\n(d) 如您出现违反中国有关法律、法规或者本网站服务协议或相关规则的情况，需要向第三方披露；\n(e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；",
        },
        {
          title: "信息存储和交换",
          text: "本网站收集的有关您的信息和资料将保存在本网站及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本网站收集信息和资料所在地的境外并在境外被访问、存储和展示。",
        },
        {
          title: "Cookie的使用",
          text: "(a) 在您未拒绝接受cookies的情况下，本网站会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本网站平台服务或功能。本网站使用cookies可为您提供更加周到的个性化服务，包括推广服务。\n(b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本网站网络服务或功能。\n(c) 通过本网站所设cookies所取得的有关信息，将适用本政策。",
        },
        {
          title: "本隐私政策的更改",
          text: "(a)如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。\n(b)本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。",
        },
      ],
    }
  },
  mounted() {},
  methods: {
    returnPage() {
      this.$router.back();
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding-top: 100px;
  position: relative;
  .bg_img {
    width: 50%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bg_img1 {
    width: 50%;
    position: absolute;
    top: 20%;
    right: 0;
  }
  .bg_img2 {
    width: 50%;
    position: absolute;
    top: 40%;
    left: 0;
  }
  .nav {
    padding: 0 160px;
    .nav_head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .img {
        width: 40px;
        height: 25px;
        margin-bottom: 20px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      }
      .nav_title {
        font-size: calc(40px * var(--scale));
        background: linear-gradient(180deg, #ffffff 0%, #2e54ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: inline-block;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
    .list {
      .list_item {
        margin: 40px;
        .title {
          width: 100%;
          color: #fff;
          font-size: calc(24px * var(--scale));
          background: linear-gradient(to right, #2a2443 0%, #020206 100%);
          margin-bottom: 15px;
          text-align: left;
          padding-left: 10px;
        }
        .text {
          font-size: calc(20px * var(--scale));
          color: #878c9e;
          text-align: left;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
